import { Helmet } from 'react-helmet-async';

const SITE = {
    name: 'A Collection of Thoughts',
    url: 'https://acollectionofthoughts.com',
    author: 'Ethan Park',
    defaultDescription:
        'A Collection of Thoughts is a portfolio of theoretical and creative works, by Aris, also known as Ethan, an Environmental Humanities student, poet, singer, and English teacher.',
    defaultImage: '/logo512.png',            // Temp placeholder; swap later
};

export default function Seo({
                                title,
                                description = SITE.defaultDescription,
                                path = '',
                                image = SITE.defaultImage,
                                type = 'website',
                                noindex = false,
                                jsonLd,
                            }) {
    const fullTitle = title ? `${title} · ${SITE.name}` : SITE.name;
    const canonical = SITE.url + path;
    const absImage = image.startsWith('http') ? image : SITE.url + image;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={canonical} />
            {noindex && <meta name="robots" content="noindex,nofollow" />}

            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE.name} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={absImage} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={absImage} />

            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    );
}

export { SITE };